import { t } from 'i18next'
import { Tag } from 'primereact/tag'

import { HistoryStatusType } from '../../../data/model'

export const statusBodyTemplate = (status?: HistoryStatusType) => {
  if (!status) return null

  const getTranslation = (status: HistoryStatusType) =>
    STATUS_TRANSLATIONS[status] || ''

  const STATUS_TRANSLATIONS: Record<HistoryStatusType, string> = {
    Canceled: t('ordersHistory.table.columns.status.options.canceled'),
    Completed: t('ordersHistory.table.columns.status.options.completed'),
    InProgress: t('ordersHistory.table.columns.status.options.inProgress'),
    Open: t('ordersHistory.table.columns.status.options.open'),
    Received: t('ordersHistory.table.columns.status.options.received'),
    Rejected: t('ordersHistory.table.columns.status.options.rejected'),
    Sent: t('ordersHistory.table.columns.status.options.sent'),
    SentWithChanges: t(
      'ordersHistory.table.columns.status.options.sentWithChanges',
    ),
  }

  const getColor = (status: HistoryStatusType) => STATUS_COLORS[status] || ''

  const STATUS_COLORS: Record<HistoryStatusType, string> = {
    Canceled: 'bg-red-200 text-red-900',
    Completed: 'bg-green-200 text-green-900',
    InProgress: 'bg-blue-200 text-blue-900',
    Open: 'bg-cyan-200 text-cyan-900',
    Received: 'bg-green-200 text-green-900',
    Rejected: 'bg-red-200 text-red-900',
    Sent: 'bg-green-200 text-green-900',
    SentWithChanges: 'bg-orange-200 text-orange-900',
  }

  return <Tag value={getTranslation(status)} className={getColor(status)}></Tag>
}
